import axios from 'axios'
import router from '../router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import qs from 'qs'
import Vue from 'vue'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('access_token')) {
      config.baseURL = process.env.VUE_APP_API_URL + 'v1/'
      config.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token')
    }
    NProgress.start()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    NProgress.done()
    return response.data
  },
  error => {
    NProgress.done()
    if (error.response) {
      
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('access_token')
          console.log("router.currentRoute.path", router.currentRoute.path)
          if (router.currentRoute.path !== "/login"){
            router.replace({
              path: '/login',
              query: {redirect:router.currentRoute.path}
            })
          }
          break
        case 404:
          var responseData = error.response
          Vue.swal({
            title: responseData && responseData.data.message ? responseData.data.message: error.message,
            icon: 'warning',
            customClass: 'animated tada'
          })
          break
        case 500:
          Vue.swal({
            title: 'Internal Server Error',
            text: error.message,
            icon: 'error'
          })
      }
    }

    // console : Error: Request failed with status code 402
    // console.log(JSON.stringify(error))

    return Promise.reject(error.response)
  }
)

export default axios
